import React from 'react'
import './index.less'
import { useEffect, useState } from 'react'
import { PaintingCard } from '@/components/PaintingCard'
import { getWorkRequest } from '@/server'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import {
  setShowType,
  setInfoKey,
  setInfoValue
} from '@/features/SetIndexSecondInfo/setIndexSecondInfo'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { getPaintingCardTrackStyle, usePaintingCardsPerPage } from '../paintingCardCarousel'

const criteriaList = {
  立轴: { content: [], count: 0 },
  长卷: { content: [], count: 0 },
  扇面: { content: [], count: 0 },
  册页: { content: [], count: 0 },
  镜片: { content: [], count: 0 },
  条屏: { content: [], count: 0 },
  横幅: { content: [], count: 0 },
  中堂: { content: [], count: 0 }
}

export function Criteria() {
  // redux获取token
  const token = useAppSelector((state) => state.login.token)
  // redux配置
  const dispatch = useAppDispatch()
  // react-router配置
  const _navigate = useNavigate()
  const cardsPerPage = usePaintingCardsPerPage()
  // 每个列表共展现作品的数目
  const perListLength = 9
  // 每个展示列表中第一个作品的index
  const [showIndex, setShowIndex] = useState<number[]>(
    new Array(Object.keys(criteriaList).length).fill(0)
  )
  // 展示作品的内容
  const [showList, setShowList] = useState<object>(criteriaList)
  // 初始化展示内容
  useEffect(() => {
    Object.keys(criteriaList).forEach((criteria) =>
      getWorkRequest(
        {
          criteria: [
            {
              key: 'style',
              value: criteria
            }
          ],
          pages: {
            page: 1,
            size: perListLength
          }
        },
        token
      ).then((res) => {
        criteriaList[criteria].content = res.data.content.list
        criteriaList[criteria].count = res.data.content.total
        const deepClone = JSON.parse(JSON.stringify(criteriaList))
        setShowList(deepClone)
      })
    )
  }, [])
  /**
   * 向小序号翻页
   * @param id: 对应DOM的id
   * @param index: 对应DOM的位序
   * @returns
   */
  const handlePre = function (index: number) {
    const newIndex = showIndex.map((x, i) => {
      if (i === index) {
        return x - cardsPerPage < 0 ? 0 : x - cardsPerPage
      } else return x
    })
    setShowIndex(newIndex)
  }
  /**
   * 向大序号翻页
   * @param id: 对应DOM的id
   * @param index: 对应DOM的位序
   * @returns
   */
  const handleNext = function (index: number, len: number) {
    const newIndex = showIndex.map((x, i) => {
      if (i === index) {
        return Math.min(x + cardsPerPage, Math.max(0, len - cardsPerPage))
      } else return x
    })
    setShowIndex(newIndex)
  }
  // 查看详情的回调，传给二级页面相应配置
  function handleIndexSecondPage(criteria) {
    dispatch(setShowType('painting'))
    dispatch(setInfoKey('style'))
    dispatch(setInfoValue(criteria))
    // navigate("/indexSecond")
    window.open('/indexSecond')
  }
  return (
    <div className='criteria-container'>
      {Object.keys(showList)
        .sort((a, b) => showList[b].count - showList[a].count)
        .map((criteria, index) => (
          <div
            className='criteria'
            style={{ display: showList[criteria].count > 0 ? 'block' : 'none' }}
          >
            <div className='criteria-title'>
              <div className='criteria-name'>{criteria}</div>
              <div className='btn-box'>
                <div
                  className={'btn ' + (showIndex[index] === 0 ? 'disabled' : 'abled')}
                  onClick={(_e) => handlePre(index)}
                >
                  <ArrowLeftOutlined
                    style={{
                      margin: 'auto',
                      color: showIndex[index] === 0 ? 'rgb(180, 179, 173)' : 'rgb(72, 66, 51)'
                    }}
                  />
                </div>
                <div
                  className={
                    'btn ' +
                    (showIndex[index] >=
                    Math.max(0, showList[criteria].content.length - cardsPerPage)
                      ? 'disabled'
                      : 'abled')
                  }
                  onClick={(_e) => handleNext(index, showList[criteria].content.length)}
                >
                  <ArrowRightOutlined
                    style={{
                      margin: 'auto',
                      color:
                        showIndex[index] >=
                        Math.max(0, showList[criteria].content.length - cardsPerPage)
                          ? 'rgb(180, 179, 173)'
                          : 'rgb(72, 66, 51)'
                    }}
                  />
                </div>
              </div>
            </div>
            <div className='criteria-subtitle'>
              <div className='criteria-count'>共计 {showList[criteria].count} 件作品</div>
              <div className='check-all-btn' onClick={() => handleIndexSecondPage(criteria)}>
                查看所有画作
                <ArrowRightOutlined
                  style={{
                    color: 'rgb(72, 66, 51)',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>
            <div className='painting-card-viewport'>
              <div className='criteria-content' style={getPaintingCardTrackStyle(showIndex[index])}>
                {showList[criteria].content.map((work) => (
                  <PaintingCard
                    title={work.workname}
                    dynasty={work.dynasty}
                    author={work.authorname}
                    museum={work.instname}
                    image={work.encoding}
                    id={work.workid}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
    </div>
  )
}
